import React, { lazy } from 'react';
import { Route, Routes } from 'react-router-dom';

const ImpactDashboard = lazy(() => import('./ImpactDashboard'));
const DistrictDashboard = lazy(() => import('./DistrictDashboard'));

export default function CeosApp() {
  return (
    <Routes>
      <Route path="impact-dashboard/*" element={<ImpactDashboard />} />
      <Route path="district-dashboard/*" element={<DistrictDashboard />} />
    </Routes>
  );
}
